import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Grid, Card, CardContent } from "@mui/material";

const GradeComponent = () => {
  const [dataGrades, setDataGrades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchAverageMarks = async () => {
      const token = localStorage.getItem("token") || "";
      const userId = localStorage.getItem("userId") || "";

      try {
        const requestOptions = {
          method: "GET",
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        };

        const response = await fetch(
          `https://beiguru.co.in/average-marks/${userId}`,
          requestOptions
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        const formattedData = result.data.map((item) => ({
          courseName: item.courseName || "Unknown Course", // Limit course name length
          grade: item.averageMarks, // Use average marks as grade
          semester: item.semester || "N/A", // Add semester if available
        }));

        setDataGrades(formattedData);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch data");
        setLoading(false);
      }
    };

    fetchAverageMarks();
  }, []);

  // Get unique semesters from the data
  const semesters = [...new Set(dataGrades.map((grade) => grade.semester))];

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: "bold" }}>
        Your Finance Courses and Grades by Semester
      </Typography>

      {loading ? (
        <Typography variant="body1">Loading...</Typography>
      ) : error ? (
        <Typography variant="body1" color="error">
          {error}
        </Typography>
      ) : (
        semesters.map((semester) => (
          <Paper key={semester} sx={{ padding: 3, marginBottom: 3, borderRadius: 4 }}>
            <Typography variant="h5" sx={{ marginBottom: 2 }}>
              Semester: {semester}
            </Typography>

            <Grid container spacing={2}>
              {dataGrades
                .filter((grade) => grade.semester === semester)
                .map((course, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Card>
                      <CardContent>
                        <Typography variant="h6">{course.courseName}</Typography>
                        <Typography variant="body1">Grade: {course.grade}</Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
            </Grid>
          </Paper>
        ))
      )}
    </Box>
  );
};

export default GradeComponent;